import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const VersionChecker = () => {
  const location = useLocation();
  const hasShownAlertRef = useRef(false);
  const checkInProgressRef = useRef(false);

  useEffect(() => {
    const sensitiveRoutes = ['/auth/callback', '/auth/confirm'];
    if (sensitiveRoutes.includes(location.pathname)) {
      return;
    }

    const checkVersion = async () => {
      if (checkInProgressRef.current) {
        return;
      }

      if (hasShownAlertRef.current) {
        return;
      }

      checkInProgressRef.current = true;

      try {
        const cacheBuster = Date.now();
        const response = await fetch(`/version.json?t=${cacheBuster}`, {
          cache: 'no-store',
          headers: {
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache',
            Expires: '0',
          },
        });

        if (!response.ok) {
          console.warn('Version check failed: HTTP', response.status);
          checkInProgressRef.current = false;
          return;
        }

        const data = await response.json();

        if (!data || !data.version) {
          console.warn('Version check failed: Invalid version data');
          checkInProgressRef.current = false;
          return;
        }

        const currentVersion = localStorage.getItem('appVersion');

        if (!currentVersion) {
          localStorage.setItem('appVersion', data.version);
          checkInProgressRef.current = false;
          return;
        }

        if (data.version !== currentVersion && !hasShownAlertRef.current) {
          hasShownAlertRef.current = true;

          localStorage.setItem('appVersion', data.version);

          alert('A new version is available. The page will refresh to update.');

          setTimeout(() => {
            if ('serviceWorker' in navigator) {
              navigator.serviceWorker.getRegistration().then((registration) => {
                if (registration?.waiting) {
                  registration.waiting.postMessage({ type: 'SKIP_WAITING' });
                }
              }).finally(() => {
                window.location.reload();
              });
              return;
            }

            window.location.reload();
          }, 500);
        }
      } catch (error) {
        console.error('Version check failed:', error);
      } finally {
        checkInProgressRef.current = false;
      }
    };

    hasShownAlertRef.current = false;

    checkVersion();

    const interval = setInterval(checkVersion, 300000);
    return () => clearInterval(interval);
  }, [location.pathname]);

  return null;
};

export default VersionChecker;
